import { render, staticRenderFns } from "./BbsSearch.vue?vue&type=template&id=19ca70a1&scoped=true"
import script from "./BbsSearch.vue?vue&type=script&lang=ts"
export * from "./BbsSearch.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./BbsSearch.vue?vue&type=style&index=0&id=19ca70a1&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "19ca70a1",
  "2f246d46"
  
)

export default component.exports